import _ from "underscore";

import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledPopover, PopoverBody } from "reactstrap";

import ClassNames from 'classnames';
import TerminalSearch from './TerminalSearch';
import Icon from "shared/react_components/MaterialIcon";

const DEFAULT_GROUP_NAME = 'All';

class Sidebar extends React.Component {
  constructor(...args) {
    super(...args);

    this.state = {
      searchText: ""
    };

    this.handleUserInput = this.handleUserInput.bind(this);
  }

  handleUserInput(searchText) {
    this.setState({
      searchText: searchText
    });
  }

  render() {
    var index = 1;
    return (
      <div className={ ClassNames('sidebar', { 'sidebar-disabled': this.props.disabled }) }>
        {this.props.description && <h6 style={{ paddingTop: 15 }}>{this.props.description}</h6>}
        <TerminalSearch
          searchText={this.state.searchText}
          onUserInput={this.handleUserInput}
        />
        {_.map(this._nodeGroups(), function(nodeNames, groupName) {
          return (
            <GroupTerminal
              key={groupName}
              nodeNames={nodeNames}
              groupName={groupName}
              index={index++}
              onTerminalClick={this.props.onInsertTerminal}
              terminalMetaData={this.props.terminalMetaData}
            />);
        }, this)}
      </div>
    );
  }

  _nodeGroups() {
    const groups = {};

    _.each(this.props.terminalMetaData, ({ access, displayName, groupName }, terminalName) => {
      const groupKey = _.isUndefined(groupName) ? DEFAULT_GROUP_NAME : groupName;
      groups[groupKey] = groups[groupKey] || [];

      if (this._terminalAccess(access)) {
        if (this.state.searchText === "" || displayName.match(new RegExp(this.state.searchText, "i"))) {
          groups[groupKey].push(terminalName);
        }
      }
    });

    return _.omit(groups, _.isEmpty);
  }

  _terminalAccess(access) {
    if (!access) {
      return true;
    } else if (access.values) {
      return _.contains(access.values, this.props.features[access.feature]);
    } else if (access.feature) {
      return this.props.features[access.feature];
    } else if (access.sharedTerminal) {
      return false;
    }
  }
}

Sidebar.propTypes = {
  features: PropTypes.object.isRequired,
  onInsertTerminal: PropTypes.func.isRequired,
  terminalMetaData: PropTypes.object.isRequired,
  description: PropTypes.string,
  disabled: PropTypes.bool
};

class GroupTerminal extends React.Component {
  render() {
    const namedGroup = this.props.groupName !== DEFAULT_GROUP_NAME;
    return (
      <div>
        {namedGroup && <h4>{this.props.groupName}</h4>}
        <ul>
          {_.map(this.props.nodeNames, function(nodeName) {
            return (
              <li
                key={this.props.groupName + ':' + nodeName}
                onClick={this.props.onTerminalClick.bind(null, nodeName)}
                className={namedGroup ? '' : 'ml-0'}
              >
                {this.props.terminalMetaData[nodeName].displayName}
                {this.renderTerminalHelpIcon(nodeName, this.props.terminalMetaData[nodeName].helpText)}
              </li>);
          }, this)}
        </ul>
      </div>
    );
  }

  renderTerminalHelpIcon(nodeName, helpText) {
    if (helpText) {
      return (
        <React.Fragment>
          <Icon id={"help-icon-" + nodeName} className="color-info p-1" name="help" style={{ verticalAlign: "middle" }}/>
          <UncontrolledPopover trigger="hover" placement="top" target={"help-icon-" + nodeName}>
            <PopoverBody>
              {helpText}
            </PopoverBody>
          </UncontrolledPopover>
        </React.Fragment>
      );
    }
  }
}

GroupTerminal.propTypes = {
  terminalMetaData: PropTypes.object.isRequired,
  onTerminalClick: PropTypes.func.isRequired,
  nodeNames: PropTypes.array,
  groupName: PropTypes.string
};

export default Sidebar;
